import type { ApiMirrorRegistryStatus } from '@fabric-app/types/connections';

export const ConnectionStatusToName: Record<ApiMirrorRegistryStatus, string> = {
  active: 'Connected',
  paused: 'Paused',
  initializing: 'Syncing',
  failed: 'Error',
  retrying: 'Retrying',
};
